import React from 'react';
import { Alert, AlertTitle, Box, Button, Paper, Typography } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

interface ErrorMessageProps {
  title?: string;
  message: string;
  onRetry?: () => void;
  severity?: 'error' | 'warning' | 'info';
  fullPage?: boolean;
}

const ErrorMessage: React.FC<ErrorMessageProps> = ({
  title = 'Error',
  message,
  onRetry,
  severity = 'error',
  fullPage = false,
}) => {
  if (fullPage) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%',
          width: '100%',
          p: 3,
          minHeight: '300px',
        }}
      >
        <Paper
          elevation={3}
          sx={{
            p: 4,
            borderRadius: 2,
            maxWidth: '500px',
            width: '100%',
            textAlign: 'center',
          }}
        >
          <ErrorOutlineIcon
            color={severity}
            sx={{ fontSize: 64, mb: 2 }}
          />
          <Typography variant="h5" component="h2" gutterBottom>
            {title}
          </Typography>
          <Typography variant="body1" color="text.secondary" paragraph>
            {message}
          </Typography>
          {onRetry && (
            <Button
              variant="contained"
              color="primary"
              onClick={onRetry}
              sx={{ mt: 2 }}
            >
              Try Again
            </Button>
          )}
        </Paper>
      </Box>
    );
  }

  return (
    <Alert
      severity={severity}
      sx={{ mb: 3 }}
      action={
        onRetry && (
          <Button color="inherit" size="small" onClick={onRetry}>
            Retry
          </Button>
        )
      }
    >
      {title && <AlertTitle>{title}</AlertTitle>}
      {message}
    </Alert>
  );
};

export default ErrorMessage;
